module.exports = __webpack_public_path__ + "img/podium.f515e730.png";